<template>
  <div class="search-page">
    <Search @handleSearch="getList" :search="searchTxt" />
    <div class="result-list">
      <div class="result-list-title">搜索结果：{{ resultList.length }}条</div>
      <div :style="{ overflowY: 'scroll', height: resultHeight + 'px' }">
        <div
          class="result-list-box"
          v-for="(item, i) in resultList"
          :key="i"
          @click="goDetailPage(item)"
        >
          <div class="name" v-if="item.type == '0'">
            <div style="font-size: 15px;font-weight: 500;">{{ item.companyName }}</div>
          </div>
          <div class="name" v-if="item.type == '1'">
            <div style="font-size: 15px;font-weight: 500;">{{ item.dealerName }}</div>
          </div>
          <div class="name" v-if="item.type == '2'">
            <div style="font-size: 15px;font-weight: 500;">{{ item.name }}</div>
            <div style="font-weight: 600;">
              <span class="grey">PPN : </span><span style="color:#DD3349">{{ item.ppn }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import Search from './search'
import { searchList } from '@/api/user/index.js'
export default {
  name: 'searchPage',
  components: { Search },
  data() {
    return {
      searchTxt: '',
      resultList: [],
      resultHeight: document.documentElement.clientHeight - 110,
    }
  },
  methods: {
    // handleSearch() {
    //   this.getList()
    // },
    getList(txt) {
      this.searchTxt = txt
      searchList({
        search: this.searchTxt,
      }).then((res) => {
        this.resultList = res.data
      })
    },
    goDetailPage(row) {
      if (row.type == '1') {
        this.$router.push({
          path: '/dealerIndex',
          query: { id: row.dealerId },
        })
      } else if (row.type == '2') {
        this.$router.push({
          path: '/userIndex',
          query: { id: row.ppn },
        })
      }
    },
  },
  created() {},
  mounted() {
    //this.searchTxt = this.$route.query.txt
    this.getList(this.$route.query.txt)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-page {
  padding: 20px;
  .result-list {
    &-title {
      color: rgb(64, 63, 69);
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 12px;
    }
    &-box {
      font-size: 12px;
      padding: 10px 16px;
      background-color: #fff;
      margin-bottom: 8px;
      & > div {
        margin-bottom: 6px;
      }
      .name {
        display: flex;
        justify-content: space-between;
      }
      .grey {
        color: rgba(115, 114, 120, 1);
      }
    }
  }
}
</style>
